import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";

export const swiperCreateNew = (sectionId) => {
	const thisSection = document.getElementById(sectionId);
	const swiperElem = thisSection?.querySelector(".swiper");

	const thisSwiper = new Swiper(swiperElem, {
		modules: [Autoplay, EffectFade],
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: false,
		lazy: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			disableOnInteraction: false,
			delay: 5000,
		},
	});

	return thisSwiper;
};
